import { createAsyncThunk } from "@reduxjs/toolkit";
import localhost from "apis/localhost";

const BASE = "/api/custom-fields";

export const fetchCustomFieldValues = createAsyncThunk(
  "customFieldValues/fetch",
  async ({ entityType, entityId }) => {
    const { data } = await localhost.get(`${BASE}/${entityType}/${entityId}/values`);
    return { entityType, entityId, values: data };
  }
);

const toUpdateItem = ({ persons, ...rest }) => ({
  ...rest,
  ...(persons !== null && persons !== undefined ? { personUserIds: persons.map((p) => p.userId) } : {}),
});

export const saveCustomFieldValues = createAsyncThunk(
  "customFieldValues/save",
  async ({ entityType, entityId, values }, { rejectWithValue }) => {
    try {
      const { data } = await localhost.put(`${BASE}/${entityType}/${entityId}/values`, {
        values: values.map(toUpdateItem),
      });
      return { entityType, entityId, values: data };
    } catch (err) {
      return rejectWithValue(err.response?.data ?? null);
    }
  }
);
